import { defineMessages } from 'react-intl';

export default defineMessages({
  userElevatorIntegrationSettingsLabel: {
    defaultMessage: 'Elevator integration',
    description: 'User Elevator integration settings - label',
    id: 'userElevatorIntegrationSettings.label',
  },
});
